import { IterableElement } from 'type-fest'
import { ARBITRUM_TOKEN_TICKERS } from './token-tickers'

import { Ticker } from '../ticker'

export const ARBITRUM_TICKERS = [Ticker.ETH, ...ARBITRUM_TOKEN_TICKERS]

export type ArbitrumTicker = IterableElement<typeof ARBITRUM_TICKERS>
